import { ref } from 'vue';

export const iframeAuthRef = ref<any>(null);
